// extracted by mini-css-extract-plugin
export default {"recos":"a7-z","productCardOverride":"b7-z","rowHasBadge":"c7-z"};